import { ChangeEvent, useState } from 'react';

import { InputProps as StandardInputProps } from '@material-ui/core/Input/Input';

import { debounced } from '@/utils/helpers';

type ReturnValue = [ inputValue: string, onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void ];

export default function useDebouncedInputChange(onChange: StandardInputProps['onChange'], initialValue: string, delay: number = 200): ReturnValue {
  const [value, setValue] = useState(initialValue);

  const debouncedOnChange = ((e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!onChange) { return; }
    setValue(e.target.value);
    debounced(delay, onChange)(e);
  });

  return [value, debouncedOnChange];
}
